import { StackScreenProps } from "@react-navigation/stack";
import { ActionsRootParamList } from "../../../../types";
import { useSaleControllerProvider } from "../../utils/sale-controller";
import { useCallback, useEffect, useState } from "react";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { View } from "react-native-ui-lib";
import {
  Page,
  TextField,
  TextButton,
  Button,
} from "@towersystems/roam-common-native";

export type EditSaleNoteScreenProps = StackScreenProps<
  ActionsRootParamList,
  "EditSaleNoteScreen"
>;

export const EditSaleNoteScreen = ({ navigation }: EditSaleNoteScreenProps) => {
  const { sale } = useSaleControllerProvider();
  const [value, setValue] = useState(sale?.note || "");
  const shouldFocus = useHasTransitionEnded(navigation);
  const title = sale?.note ? "Edit Staff Note" : "Add Staff Note";

  const handleOnSave = useCallback(() => {
    return sale
      ?.updateSaleNote(value)
      .then(() => navigation.goBack())
      .catch((err) => console.log(err));
  }, [sale, value]);

  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Button
          label="Save Note"
          isAction
          size="compact"
          onPress={() => handleOnSave()}
        ></Button>
      ),
    });
  }, [title, handleOnSave]);

  const footer = sale?.note ? (
    <View>
      <Button
        onPress={() => {
          sale?.updateSaleNote("");
          navigation.goBack();
        }}
        label="Remove Note"
        isDestructive
      ></Button>
    </View>
  ) : null;

  return (
    <Page scrollable={false} footer={footer}>
      <View style={{ height: "100%" }} flex>
        <TextField
          textarea
          placeholder="Leave a staff note..."
          value={value}
          onChangeText={(v) => setValue(v)}
          autoFocus={shouldFocus}
        />
      </View>
    </Page>
  );
};
